import { h } from 'preact';

export const DOG_VIEWBOX = '0 0 665 1000';

export const DOG_TEETH = [
    // Upper incisors: Triadan numbers from the midline outward, so the central
    // incisors (nearest the midline) are 101/201 and the corner incisors
    // (nearest the canines) are 103/203.
    { id: '103', cx: 199, cy: 83, rx: 7, ry: 14, rot: -22, kind: 'incisor' },
    { id: '102', cx: 213, cy: 78, rx: 7, ry: 14, rot: -16, kind: 'incisor' },
    { id: '101', cx: 228, cy: 76, rx: 7, ry: 14, rot: -8, kind: 'incisor' },
    { id: '201', cx: 244, cy: 76, rx: 7, ry: 14, rot: 8, kind: 'incisor' },
    { id: '202', cx: 259, cy: 78, rx: 7, ry: 14, rot: 16, kind: 'incisor' },
    { id: '203', cx: 274, cy: 83, rx: 7, ry: 14, rot: 22, kind: 'incisor' },
    { id: '104', cx: 169, cy: 126, rx: 14, ry: 31, rot: 10, kind: 'canine' },
    { id: '204', cx: 313, cy: 126, rx: 14, ry: 31, rot: -10, kind: 'canine' },
    { id: '105', cx: 148, cy: 178, rx: 6, ry: 10, rot: 12, kind: 'premolar' },
    { id: '106', cx: 132, cy: 225, rx: 8, ry: 14, rot: 14, kind: 'premolar' },
    { id: '107', cx: 118, cy: 275, rx: 9, ry: 18, rot: 16, kind: 'premolar' },
    { id: '108', cx: 104, cy: 330, rx: 11, ry: 24, rot: 18, kind: 'premolar' },
    { id: '109', cx: 98, cy: 392, rx: 10, ry: 16, rot: 14, kind: 'molar' },
    { id: '110', cx: 95, cy: 442, rx: 8, ry: 12, rot: 8, kind: 'molar' },
    { id: '205', cx: 334, cy: 178, rx: 6, ry: 10, rot: -12, kind: 'premolar' },
    { id: '206', cx: 350, cy: 225, rx: 8, ry: 14, rot: -14, kind: 'premolar' },
    { id: '207', cx: 364, cy: 275, rx: 9, ry: 18, rot: -16, kind: 'premolar' },
    { id: '208', cx: 378, cy: 330, rx: 11, ry: 24, rot: -18, kind: 'premolar' },
    { id: '209', cx: 384, cy: 392, rx: 10, ry: 16, rot: -14, kind: 'molar' },
    { id: '210', cx: 387, cy: 442, rx: 8, ry: 12, rot: -8, kind: 'molar' },
    { id: '411', cx: 120, cy: 540, rx: 7, ry: 10, rot: -8, kind: 'molar' },
    { id: '410', cx: 125, cy: 585, rx: 9, ry: 14, rot: -12, kind: 'molar' },
    { id: '409', cx: 132, cy: 640, rx: 12, ry: 24, rot: -15, kind: 'molar' },
    { id: '408', cx: 140, cy: 700, rx: 9, ry: 18, rot: -16, kind: 'premolar' },
    { id: '407', cx: 151, cy: 748, rx: 8, ry: 15, rot: -16, kind: 'premolar' },
    { id: '406', cx: 164, cy: 788, rx: 8, ry: 14, rot: -16, kind: 'premolar' },
    { id: '405', cx: 180, cy: 826, rx: 6, ry: 11, rot: -16, kind: 'premolar' },
    { id: '311', cx: 365, cy: 540, rx: 7, ry: 10, rot: 8, kind: 'molar' },
    { id: '310', cx: 360, cy: 585, rx: 9, ry: 14, rot: 12, kind: 'molar' },
    { id: '309', cx: 353, cy: 640, rx: 12, ry: 24, rot: 15, kind: 'molar' },
    { id: '308', cx: 345, cy: 700, rx: 9, ry: 18, rot: 16, kind: 'premolar' },
    { id: '307', cx: 334, cy: 748, rx: 8, ry: 15, rot: 16, kind: 'premolar' },
    { id: '306', cx: 321, cy: 788, rx: 8, ry: 14, rot: 16, kind: 'premolar' },
    { id: '305', cx: 305, cy: 826, rx: 6, ry: 11, rot: 16, kind: 'premolar' },
    { id: '404', cx: 200, cy: 878, rx: 14, ry: 28, rot: 82, kind: 'canine' },
    { id: '304', cx: 285, cy: 878, rx: 14, ry: 28, rot: -82, kind: 'canine' },
    { id: '403', cx: 205, cy: 901, rx: 7, ry: 13, rot: 31, kind: 'incisor' },
    { id: '402', cx: 220, cy: 906, rx: 7, ry: 13, rot: 22, kind: 'incisor' },
    { id: '401', cx: 235, cy: 908, rx: 7, ry: 13, rot: 9, kind: 'incisor' },
    { id: '301', cx: 250, cy: 908, rx: 7, ry: 13, rot: -9, kind: 'incisor' },
    { id: '302', cx: 265, cy: 906, rx: 7, ry: 13, rot: -22, kind: 'incisor' },
    { id: '303', cx: 280, cy: 901, rx: 7, ry: 13, rot: -31, kind: 'incisor' },
];

// Deciduous (melketann) label boxes, TICKET-01850. Triadan quadrant + 4:
// 1xx -> 5xx, 2xx -> 6xx, 3xx -> 7xx, 4xx -> 8xx. Only incisors, canines and
// premolars 6-8 have a deciduous predecessor. `x`/`y` is the top-left corner of
// the small clickable box; incisor boxes sit beside the permanent label (there
// is no vertical room between those labels), canine/premolar boxes sit just
// below theirs.
export const DOG_DECIDUOUS = [
    { id: '501', x: 116, y: 16 },
    { id: '502', x: 106, y: 35 },
    { id: '503', x: 99, y: 54 },
    { id: '601', x: 326, y: 16 },
    { id: '602', x: 336, y: 35 },
    { id: '603', x: 341, y: 54 },
    { id: '504', x: 83, y: 132 },
    { id: '604', x: 374, y: 132 },
    { id: '506', x: 50, y: 231 },
    { id: '507', x: 35, y: 281 },
    { id: '508', x: 20, y: 336 },
    { id: '606', x: 416, y: 231 },
    { id: '607', x: 432, y: 281 },
    { id: '608', x: 448, y: 336 },
    { id: '808', x: 20, y: 708 },
    { id: '807', x: 30, y: 756 },
    { id: '806', x: 42, y: 796 },
    { id: '708', x: 445, y: 708 },
    { id: '707', x: 430, y: 756 },
    { id: '706', x: 418, y: 796 },
    { id: '804', x: 100, y: 888 },
    { id: '704', x: 358, y: 888 },
    { id: '803', x: 95, y: 921 },
    { id: '802', x: 95, y: 940 },
    { id: '801', x: 95, y: 959 },
    { id: '703', x: 334, y: 921 },
    { id: '702', x: 334, y: 940 },
    { id: '701', x: 334, y: 959 },
];

export function DogChartStatic() {
    return (
        <g>
            <path class='dc-jaw' d='M 176 91 C 148 126 142 175 142 245 C 142 325 110 400 78 472 C 110 484 145 490 178 488 C 200 487 220 484 240 484 C 260 484 280 487 302 488 C 335 490 370 484 402 472 C 370 400 338 325 338 245 C 338 175 332 126 304 91' />
            <path class='dc-detail' d='M 202 305 C 214 301 225 306 236 306 C 248 306 254 300 265 304 C 281 310 293 350 305 395 C 320 440 330 470 360 488' />
            <path class='dc-detail' d='M 202 305 C 183 320 170 360 158 405 C 148 445 138 470 110 482' />
            <path class='dc-jaw' d='M 107 510 C 123 580 143 660 145 760 C 147 810 143 845 153 868 C 162 888 185 890 199 873 C 201 905 219 925 235 915 C 250 932 270 925 283 905 C 300 915 323 905 331 868 C 341 845 337 810 339 760 C 341 660 361 580 377 510' />
            <path class='dc-detail' d='M 136 510 L 237 880 C 240 892 244 894 248 882 L 348 510' />
            <text class='dc-jaw-label' x='209' y='270'>Upper Jaw</text>
            <text class='dc-jaw-label' x='209' y='585'>Lower Jaw</text>
        </g>
    );
}

export function DogChartLabels() {
    return (
        <g>
            <text class='dc-label' x='160' y='30'>101</text>
            <polyline class='dc-leader' points='185,26 222,26 228,64' />
            <text class='dc-label' x='150' y='49'>102</text>
            <polyline class='dc-leader' points='177,45 204,45 214,67' />
            <text class='dc-label' x='143' y='68'>103</text>
            <polyline class='dc-leader' points='171,64 194,64 203,74' />
            <text class='dc-label' x='294' y='30'>201</text>
            <polyline class='dc-leader' points='294,26 250,26 244,64' />
            <text class='dc-label' x='304' y='49'>202</text>
            <polyline class='dc-leader' points='304,45 264,45 259,66' />
            <text class='dc-label' x='309' y='68'>203</text>
            <polyline class='dc-leader' points='309,64 280,64 274,72' />
            <text class='dc-label' x='83' y='128'>104</text>
            <line class='dc-leader' x1='111' y1='124' x2='154' y2='124' />
            <text class='dc-label' x='374' y='128'>204</text>
            <line class='dc-leader' x1='353' y1='124' x2='367' y2='124' />
            <text class='dc-label' x='65' y='180'>105</text>
            <line class='dc-leader' x1='92' y1='176' x2='142' y2='176' />
            <text class='dc-label' x='50' y='227'>106</text>
            <line class='dc-leader' x1='78' y1='223' x2='124' y2='223' />
            <text class='dc-label' x='35' y='277'>107</text>
            <line class='dc-leader' x1='63' y1='273' x2='109' y2='273' />
            <text class='dc-label' x='20' y='332'>108</text>
            <line class='dc-leader' x1='48' y1='328' x2='93' y2='328' />
            <text class='dc-label' x='20' y='392'>109</text>
            <line class='dc-leader' x1='48' y1='388' x2='88' y2='388' />
            <text class='dc-label' x='20' y='442'>110</text>
            <line class='dc-leader' x1='48' y1='438' x2='87' y2='438' />
            <text class='dc-label' x='402' y='180'>205</text>
            <line class='dc-leader' x1='362' y1='176' x2='340' y2='176' />
            <text class='dc-label' x='416' y='227'>206</text>
            <line class='dc-leader' x1='376' y1='223' x2='358' y2='223' />
            <text class='dc-label' x='432' y='277'>207</text>
            <line class='dc-leader' x1='392' y1='273' x2='373' y2='273' />
            <text class='dc-label' x='448' y='332'>208</text>
            <line class='dc-leader' x1='408' y1='328' x2='389' y2='328' />
            <text class='dc-label' x='448' y='392'>209</text>
            <line class='dc-leader' x1='408' y1='388' x2='394' y2='388' />
            <text class='dc-label' x='448' y='442'>210</text>
            <line class='dc-leader' x1='408' y1='438' x2='395' y2='438' />
            <text class='dc-label' x='20' y='544'>411</text>
            <line class='dc-leader' x1='48' y1='540' x2='113' y2='540' />
            <text class='dc-label' x='20' y='589'>410</text>
            <line class='dc-leader' x1='48' y1='585' x2='116' y2='585' />
            <text class='dc-label' x='20' y='644'>409</text>
            <line class='dc-leader' x1='48' y1='640' x2='120' y2='640' />
            <text class='dc-label' x='20' y='704'>408</text>
            <line class='dc-leader' x1='48' y1='700' x2='131' y2='700' />
            <text class='dc-label' x='30' y='752'>407</text>
            <line class='dc-leader' x1='58' y1='748' x2='143' y2='748' />
            <text class='dc-label' x='42' y='792'>406</text>
            <line class='dc-leader' x1='70' y1='788' x2='156' y2='788' />
            <text class='dc-label' x='58' y='830'>405</text>
            <line class='dc-leader' x1='86' y1='826' x2='174' y2='826' />
            <text class='dc-label' x='100' y='884'>404</text>
            <polyline class='dc-leader' points='128,880 165,880 188,876' />
            <text class='dc-label' x='358' y='884'>304</text>
            <polyline class='dc-leader' points='358,880 320,880 297,876' />
            <text class='dc-label' x='445' y='544'>311</text>
            <line class='dc-leader' x1='445' y1='540' x2='372' y2='540' />
            <text class='dc-label' x='445' y='589'>310</text>
            <line class='dc-leader' x1='445' y1='585' x2='369' y2='585' />
            <text class='dc-label' x='445' y='644'>309</text>
            <line class='dc-leader' x1='445' y1='640' x2='365' y2='640' />
            <text class='dc-label' x='445' y='704'>308</text>
            <line class='dc-leader' x1='445' y1='700' x2='354' y2='700' />
            <text class='dc-label' x='430' y='752'>307</text>
            <line class='dc-leader' x1='430' y1='748' x2='342' y2='748' />
            <text class='dc-label' x='418' y='792'>306</text>
            <line class='dc-leader' x1='418' y1='788' x2='329' y2='788' />
            <text class='dc-label' x='402' y='830'>305</text>
            <line class='dc-leader' x1='402' y1='826' x2='311' y2='826' />
            <text class='dc-label' x='139' y='935'>403</text>
            <polyline class='dc-leader' points='169,931 188,931 203,910' />
            <text class='dc-label' x='139' y='954'>402</text>
            <polyline class='dc-leader' points='169,950 202,950 217,914' />
            <text class='dc-label' x='139' y='973'>401</text>
            <polyline class='dc-leader' points='169,969 217,969 233,917' />
            <text class='dc-label' x='302' y='935'>303</text>
            <polyline class='dc-leader' points='302,931 289,931 282,910' />
            <text class='dc-label' x='302' y='954'>302</text>
            <polyline class='dc-leader' points='302,950 275,950 268,914' />
            <text class='dc-label' x='302' y='973'>301</text>
            <polyline class='dc-leader' points='302,969 259,969 252,917' />
        </g>
    );
}
